import { useEffect, useMemo, useState } from "react";
import './Filter.scss';
import { FilterSearchBar, FilterOptions, FilterCategory, FilterAvailability, FilterSporttak, FilterDropdown, FilterDate } from './Filters';
import { FilterTrueFalse } from "./Filters/FilterTrueFalse";

export const Filter = (props) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [options, setOptions] = useState(null);
    const [render, setRender] = useState(0);
    const [filterState, setFilterState] = useState(false);

    useEffect(() => {
        if (render) {

            props.startLoading();

            if (props.ficheData.filter !== null) {

                let newFilterSettings = { ...props.ficheData.filter };
                newFilterSettings.page = 0;

                let searchBar = newFilterSettings.filters?.find(f => f.type === 0);
                if (searchBar != null) {
                    searchBar.value = searchTerm;
                }

                props.setFicheData(prev => {
                    return { ...prev, filter: newFilterSettings }
                });

            }

        }
    }, [searchTerm, JSON.stringify(options)]);

    useEffect(() => {

        if (render === 1) {

            setOptions(props.ficheData.filter.filters);

            setFilterState(props.ficheData.filter.showAlways);

        }
    }, [render]);

    const filters = useMemo(() => {

        let filters = [];

        if (props.ficheData != null) {

            if (props.ficheData.filter && props.ficheData.filter.filters) {

                for (let i = 0; i < props.ficheData.filter.filters.length; i++) {

                    const f = props.ficheData.filter.filters[i];

                    switch (f.type) {
                        //Searchbar
                        case 0:
                            filters.push(<FilterSearchBar
                                key={"filter_" + i}
                                filter={f}
                                setSearchTermHandler={setSearchTerm} />);
                            break;
                        //Options
                        case 1:
                            filters.push(<FilterOptions
                                key={"filter_" + i}
                                filter={f}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData} />);
                            break;
                        //Category
                        case 2:
                            filters.push(<FilterCategory
                                key={"filter_" + i}
                                filter={f}
                                dictionary={props.dictionary}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData} />);
                            break;
                        //Aavilability
                        case 3:
                            filters.push(<FilterAvailability
                                key={"filter_" + i}
                                filter={f}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData}
                                dictionary={props.dictionary} />);
                            break;
                        //Sporttak
                        case 4:
                            filters.push(<FilterSporttak
                                key={"filter_" + i}
                                filter={f}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData}
                                dictionary={props.dictionary} />);
                            break;
                        //Dropdown
                        case 5:
                            filters.push(<FilterDropdown
                                key={"filter_" + i}
                                filter={f}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData}
                                dictionary={props.dictionary} />);
                            break;
                        case 6:
                            filters.push(<FilterDropdown
                                key={"filter_" + i}
                                filter={f}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData}
                                dictionary={props.dictionary} />);
                            break;
                        case 7:
                            filters.push(<FilterDate
                                key={"filter_" + i}
                                filter={f}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData}
                                dictionary={props.dictionary} />);
                            break;
                        case 8:
                            filters.push(<FilterTrueFalse
                                key={"filter_" + i}
                                filter={f}
                                setFicheData={props.setFicheData}
                                ficheData={props.ficheData}
                                dictionary={props.dictionary} />);
                            break;
                    }
                }
                return filters;
            }
        }
    }, [JSON.stringify(props.ficheData.filter)]);

    //On first render
    useEffect(() => {
        if (render === 0) {
            if (props.ficheData.filter !== null) {
                setRender(render + 1);
            }
        }
    }, [JSON.stringify(props.ficheData.filter)]);

    return (
        <header className="c-section__header">
            {
                props.ficheData && props.ficheData.filter && !props.ficheData.filter.hideTitle 
                && <h2 className="title">
                {props.amount} <span>{(props.amount === 1 ? (props.ficheData.filter && props.ficheData.filter.titleSingle) : (props.ficheData.filter && props.ficheData.filter.titlePlural))}</span>
            </h2>
            }
            {
                (props.ficheData.filter && props.ficheData.filter.filters && props.ficheData.filter.filters.length > 0
                    && <div className={`filter ${props.ficheData && props.ficheData.filter && props.ficheData.filter.hideTitle ? `noTitle` : ``}`}>
                        <div className="filter-accordion ui-accordion">
                            <button className={"float-right filter-toggle ui-accordion__toggle " + (filterState ? "active" : "")} onClick={() => setFilterState(!filterState)}>
                                {props.dictionary.filter} {filterState ? <i class="fa-solid fa-caret-up"></i> : <i class="fa-solid fa-caret-down"></i>}
                            </button>
                            <div className={"filter-content ui-accordion__content " + (filterState ? "active" : "")}>
                                <div className="search u-clear">
                                    <div className="u-clear">
                                        <div className="row">
                                            {
                                                filters
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </header>
    );
}
